<section class="image-lightbox" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" [attr.aria-label]="image().fileName">
	<header class="image-lightbox__header">
		<h2>{{ image().fileName }}</h2>
		<div class="image-lightbox__actions">
			<button type="button" class="image-lightbox__button" [disabled]="downloading()" (click)="download()"
				[attr.aria-label]="'shared.imageLightbox.download' | translate">
				<app-icon icon="fa-solid fa-download" color="currentColor" [width]="16" [height]="16" />
			</button>
			<button type="button" class="image-lightbox__button" (click)="close()"
				[attr.aria-label]="'shared.imageLightbox.close' | translate">
				<app-icon icon="fa-solid fa-xmark" color="currentColor" [width]="16" [height]="16" />
			</button>
		</div>
	</header>

	<div class="image-lightbox__viewer">
		@if (loading()) {
		<p>{{ 'shared.imageLightbox.loading' | translate }}</p>
		} @else if (imageUrl()) {
		<img [src]="imageUrl()" [alt]="altText()" />
		} @else {
		<p>{{ 'shared.imageLightbox.error' | translate }}</p>
		}
	</div>
</section>
